<template>
  <div class="register">
    <nav-title title="注册卖家身份" border></nav-title>
    <!-- 有微信状态 -->
    <div class="wechat-title">成为森果云卖家后您即可注册店铺</div>
    <div class="input-box">
      <mobile-input 
        class="realname"
        v-model="realname"
        maxLength='20'
        placeholder='请输入真实姓名'
        @inputTest="inputLimitNormal($data, 'realname')"
        title='真实姓名'
      ></mobile-input>
      <code-input
         v-model='mobilePhone'
          @inputTest="inputLimitPhone($data, 'mobilePhone')"
          @focus="inputError.mobilePhone1=''"
          @blur="mobilePhone.length !== 11 && mobilePhone.length !== 0 ? inputError.mobilePhone1 = '请输入正确的11位手机号' : ''"
          :errMsg='inputError.mobilePhone1'
          @getRegisterCode='getRegisterCode'
      ></code-input>
      <mobile-input 
        title='验证码'
        class="code"
        type='tel'
        maxLength='4'
        v-model='code'
        placeholder='请输入验证码'  
        @focus="inputError.code1=''"
        @blur="code.length!==4 && code.length!==0 ? inputError.code1 ='请输入4位数验证码': ''"
        :errMsg='inputError.code1'
      ></mobile-input>
      <div class="button" v-if="!isCanRegister">注册</div>
      <div class="button cButton" v-else @click='registerEvent'>注册</div>
      <div class="read">
        <el-checkbox :value="read" @change="handleReadChange" style="margin-right: 10px;"></el-checkbox>
        <span>我已阅读并同意</span>
        <span style="color: #63A6FF" @click="seeUserAgreement">《用户协议》</span>
        <span>和</span>
        <span style="color: #63A6FF" @click="seePrivacyAgreement">《隐私协议》</span>
      </div>
    </div>
    
    <!-- 有微信登录状态 -->
    <div class="wechat" :style="'top:' + windowHeight">
      <span @click="logoutEvent">退出登录</span>
    </div>
    <!-- ypsdk -->
    <ypsdk ref="ypsdk" />
  </div>
</template>

<script>
import CodeInput from '../components/code-input/code-input'
import { inputLimitPhone, inputLimitNormal, initPluginsWithPrivacy } from '@/utils'
import domain from '@/config/systemDomain'
import { isAndroid } from '@/assets/js/util'
import { privacyUrl, userUrl } from "@/config/config";

// sdk
import ypsdk from '@/components/ypsdk/ypsdk'
export default {
  data() {
    return {
      realname: '' , 
      mobilePhone: '' , 
      code: '',
      inputError: {
        realname1: '',
        mobilePhone1: '',
        code1: ''
      },
      isGettingCode: false,
      windowHeight: '',
      read: false,
      shake: false
    }
  },

  computed: {
    isCanRegister: function() {
      return this.realname && this.mobilePhone.length === 11 && this.code.length === 4
    }
  },

  created() {
    this.inputLimitPhone = inputLimitPhone
    this.inputLimitNormal = inputLimitNormal
    this.firstPicValid = true
    this.windowHeight = document.body.clientHeight - 30 - 20 + 'px'  // 底部 30 自身 20
  },
  
  beforeRouteLeave(to, from, next) {
    if (to.path === '/mobileInit') {
      this.$fetch.post({
        url: '/login?method=logout'
      }).finally(() => {
        next()
      })
    }
    
  },

  methods: {
    getRegisterCode() {  // 获取验证码 
      this.vertifyCode()
    }, 

    vertifyCode(captchaVerifyParam) {  // 验证码校验
      const params = {
        action: 'bind',
        phone: this.mobilePhone
      }
      if (captchaVerifyParam) {
        // 图片验证
        params.captcha_verify_param = captchaVerifyParam;
      }
      // 获取验证码的请求 
      return this.$fetch.post({
        url: '/captcha',
        params
      }).then( data => {
        if (data.need_captcha && this.firstPicValid) {
          // 接口判断是否需要图片验证 
          this.firstPicValid = false
          this.ypValid()
        } else {
          this.firstPicValid = true
        }
        return data
      }, e => {
        if(!e.success && e.error_text.includes('图形验证') && this.firstPicValid) {
          this.firstPicValid = false 
          return this.ypValid()
        }
        this.firstPicValid = true;
        this.openMessage(0, e.error_text || '获取验证码失败')
        if (captchaVerifyParam) return Promise.reject(e)
      })

    },

    ypValid() {
      this.$nextTick(() => {
        this.$refs.ypsdk.ready(
          captchaVerifyParam => this.vertifyCode(captchaVerifyParam)
        ).then(() => {}, () => {})
      })
    },


    registerEvent() {  // 绑定手机号
      if (!this.read) {
        return this.openMessage(0, '请先同意用户协议再注册')
      }
      
      if (this.shake) return
      this.shake = true
      this.$fetch.post({
        url: '/user',
        params: {
          phone: this.mobilePhone,
          code: this.code,
          realname: this.realname
        }
      }).then( (data) => {
         this.shake = false
          if (data.success && data.bind_wx && data.done) {
            window.location.href = domain.center_domain_m + '/#/loading'
          } else if (!data.bind_wx) {
            // 未绑定微信， 去绑定微信
            if (isAndroid()) {
              try {
                window.Assistant.getWxLoginCode('bindWxCallback')
              } catch(e) {
                this.openMessage(0, '暂无客户端授权')
              }
            } else {
              try {
                window.webkit.messageHandlers.NativeApi.postMessage({"func": "getWxLoginCode", "param": "bindWxCallback"})
              } catch {
                this.openMessage(0, '暂无客户端授权')
              }
            }
          }
      }).catch((e) => {
         this.shake = false
        this.openMessage(0 , e.error_text || '绑定失败')
      }).finally( () => {
        this.code = ''
      })
    },
  
    seeUserAgreement() {
      window.location.href = userUrl
    },

    seePrivacyAgreement () {
      window.location.href = privacyUrl
    },

    logoutEvent() {
      console.log('ok')
      if (this.logoutLock) return
      console.log('no')
      this.logoutLock = true
      this.$fetch.post({
        url: '/login?method=logout'
      }).finally(() => {
        this.$router.push({path: '/mobileInit'})
      })
    },

    handleReadChange(val) {
      this.read = val
      if (val) {
        initPluginsWithPrivacy()
      }
    }
  },

  components: {
    CodeInput,
    ypsdk
  }
};
</script>

<style lang='scss' scoped>
html, body {
  ::-webkit-scrollbar {
      width: 0;
      height: 16px;
      background-color: #F5F5F5;
  }
}
.register {
  position: relative;
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;

  .wechat-title {
    margin-top: 30px;
    font-size: 20px;
    line-height: 28px;
    font-weight: bold;
    color: #333;
    text-align: center;
  }
  .input-box {
    padding: 0 10px;
  }

  .realname {
    margin-top: 40px;
    margin-bottom: 10px;
  }

  .code {
    margin-top: 10px;
  }

  .button {
    margin-top: 10px;
    width: 100%;
    height: 50px;
    line-height: 50px;
    color: #fff;
    border-radius: 5px;
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    background-color: #ddd;
  }

  .cButton {
    background-color: #009688;

    &:active {
     background-color: rgba(0,134,122,100);
    }
  }

  .no-wechat {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    position: fixed;
    width: 100%;
    bottom: 10%;

    .icon {
      font-size: 50px;
    }

    .tip {
      margin-top: 6px;
      font-size: 14px;
      color: #666;
    }
  }

  .wechat {
    position: absolute;
    top: 200px;
    left: 0;
    text-align: center;
    width: 100%;

    span {
      display: inline-block;
      height: 20px;
      font-size: 14px;
      line-height: 20px;
      color: #999;
      border-bottom: 1px solid #999;
    }
  }

  .read {
    margin-top: 20px;
    text-align: center;
    font-size: 14px;
  }
}
</style>
